<template>
  <div class="hhxc-tabs">
    <div class="hhxc-tabs-inner">
      <a-tabs type="card" :editable="true" :active-key="tabsKey" @delete="handleTabRemove" @change="handleTabClick">
        <!-- <a-tab-pane
          v-for="item in visitedRoutes"
          :key="item.path"
          :title="item.meta.title"
          :closable="item.fullPath === '/index' ? false : true"
        /> -->
        <a-tab-pane key="/index" title="首页" :closable="false" />
        <a-tab-pane v-for="item in visitedRoutes.filter((item) => item && item.path !== '/index')" :key="item.path" :title="item.meta.title" :closable="item.fullPath === '/index' ? false : true" />
      </a-tabs>
    </div>
    <div>
      <a-dropdown>
        <template #content>
          <a-doption @click="handleClick('closeOthersTabs')">关闭其他</a-doption>
          <a-doption @click="handleClick('closeLeftTabs')">关闭左侧</a-doption>
          <a-doption @click="handleClick('closeRightTabs')">关闭右侧</a-doption>
          <a-doption @click="handleClick('closeAllTabs')">关闭全部</a-doption>
        </template>
        <icon-more class="hhxc-tabs-more" />
      </a-dropdown>
      <a-divider direction="vertical" />
    </div>
  </div>
</template>

<script>
  import { getLocal, setLocal } from '@/utils/index'
  import { computed, reactive, toRefs, watch } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { useStore } from 'vuex'
  export default {
    name: 'HhxcTabs',
    setup() {
      const $route = useRoute()
      const store = useStore()
      const $router = useRouter()
      const myState = reactive({
        affixTabs: [],
        tabActive: null,
        created: false,
        tabsKey: $route.path,
      })
      const asyncRoutes = computed(() => store.getters['user/flatMenuList'])

      const visitedRoutes = computed(() => store.getters['tagsBar/visitedRoutes'])
      const routes = computed(() => store.getters['tagsBar/routes'])
      const addVisitedRoute = (route) => {
        return store.dispatch('tagsBar/addVisitedRoute', route)
      }
      const delVisitedRoute = (view) => {
        return store.dispatch('tagsBar/delVisitedRoute', view)
      }
      const delOthersVisitedRoutes = (route) => {
        return store.dispatch('tagsBar/delOthersVisitedRoutes', route.fullPath)
      }
      const delLeftVisitedRoutes = (route) => {
        return store.dispatch('tagsBar/delLeftVisitedRoutes', route)
      }
      const delRightVisitedRoutes = (route) => {
        return store.dispatch('tagsBar/delRightVisitedRoutes', route)
      }
      const delAllVisitedRoutes = () => {
        return store.dispatch('tagsBar/delAllVisitedRoutes')
      }
      watch($route, () => {
        myState.tabsKey = $route.path
        addTabs($route)
      })
      const addTabs = async (tag) => {
        if (tag.name && tag.meta && tag.hidden !== true) {
          // 从后端获取路由的title赋值到routes中的title
          asyncRoutes.value.map((w) => {
            if (w.path === tag.path) {
              return (tag.meta.title = w.meta.title)
            }
          })
          let matched = [tag.name]
          if (tag.matched) matched = tag.matched.map((item) => item.name)
          await addVisitedRoute({
            path: tag.path,
            fullPath: tag.fullPath,
            query: tag.query,
            params: tag.params,
            name: tag.name,
            matched: matched,
            meta: { ...tag.meta },
          })
          myState.tabActive = tag.fullPath
        }
      }
      const initAffixTabs = (routes) => {
        if (routes) return
        routes.forEach((route) => {
          if (route.meta && route.meta.affix) addTabs(route)
          if (route.children) initAffixTabs(route.children)
        })
      }
      const isActive = (route) => {
        return route.path === $route.path
      }
      // const isAffix = (tag) => {
      //   return tag.meta && tag.meta.affix
      // }
      const handleTabClick = (path) => {
        myState.tabsKey = path
        const route = visitedRoutes.value.filter((item) => item?.path === path)[0]
        if ($route?.fullPath !== route?.fullPath) $router.push(route?.fullPath || route?.path || path)
      }
      const handleTabRemove = async (path) => {
        const view = visitedRoutes.value.find((item) => {
          return path === item.path
        })
        await delVisitedRoute(view)
        let tabs = JSON.parse(getLocal('hhxcNav-list'))
        tabs.forEach((item, index) => {
          if (path === item.path) {
            tabs.splice(index, 1)
          }
        })
        setLocal('hhxcNav-list', JSON.stringify(tabs))
        if (isActive(view)) toLastTag()
      }
      const handleClick = (key) => {
        switch (key) {
          case 'closeOthersTabs':
            closeOthersTabs()
            break
          case 'closeLeftTabs':
            closeLeftTabs()
            break
          case 'closeRightTabs':
            closeRightTabs()
            break
          case 'closeAllTabs':
            closeAllTabs()
            break
        }
      }
      const closeSelectedTag = async (view) => {
        await delVisitedRoute(view)

        if (isActive(view)) {
          toLastTag()
        }
      }
      const closeOthersTabs = async () => {
        await delOthersVisitedRoutes(toThisTag())
      }
      const closeLeftTabs = async () => {
        await delLeftVisitedRoutes(toThisTag())
      }
      const closeRightTabs = async () => {
        await delRightVisitedRoutes(toThisTag())
      }
      const closeAllTabs = async () => {
        await delAllVisitedRoutes()
        if (myState.affixTabs.some((tag) => tag.path === toThisTag().path)) return
        toLastTag()
      }
      const toLastTag = () => {
        const latestView = visitedRoutes.value.slice(-1)[0]
        if (latestView) $router.push(latestView)
        else $router.push('/')
      }
      const toThisTag = () => {
        const view = visitedRoutes.value.find((item) => item.fullPath === $route.fullPath)
        if ($route.path !== view.path) $router.push(view)
        return view
      }
      initAffixTabs(routes)
      addTabs($route)
      return {
        ...toRefs(myState),
        asyncRoutes,
        visitedRoutes,
        routes,
        delVisitedRoute,
        addVisitedRoute,
        delOthersVisitedRoutes,
        delLeftVisitedRoutes,
        delRightVisitedRoutes,
        delAllVisitedRoutes,
        addTabs,
        handleTabClick,
        handleTabRemove,
        handleClick,
        closeSelectedTag,
      }
    },
  }
</script>
<style lang="less" scoped>
  .hhxc-tabs {
    padding: 0 @space-sm;
    height: calc(@hhxc-header-height - 2px);
    display: flex;
    justify-content: space-between;
    background: #fff;
    align-items: center;
    &-inner {
      height: 100%;
      width: 90%;
      display: flex;
      align-items: center;
      cursor: pointer;
      :deep(.arco-tabs-nav::before) {
        height: 0;
      }
    }
    &-more {
      cursor: pointer;
    }
  }
  .hhxc-divider-vertical {
    display: inline-block;
    min-width: 1px;
    max-width: 1px;
    height: 1em;
    margin: 0 12px;
    vertical-align: middle;
    border-left: 1px solid #e5e6eb;
  }
  :deep(.arco-tabs-content) {
    padding-top: 0px;
    display: none;
  }
  :deep(.arco-tabs-nav-tab-list) {
    .arco-tabs-tab {
      border: none !important;
    }
    .arco-tabs-tab + .arco-tabs-tab {
      border-left: 1px solid var(--color-neutral-3) !important;
    }
  }
</style>
